import { filter } from 'lodash';
import * as t from './actionTypes';

const initialState = {
    loadingReports: true,
    loadingDetails: true,
    reports: [],
    myreports: [],
    compliancereports: [],
    waitingreports: [],
    delegatedreports: [],
    selectedYear: new Date().getFullYear(),
    selectedTab: '1',
    selectedDetailReport: {},
    selectedDetailReportIsDirty: false,
    approvalorder: [],
    selectedTab: '1',
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_MYREPORTS:
            return Object.assign({}, state, {
                myreports: action.payload
            });
        case t.LOAD_REPORTS:
            return Object.assign({}, state, {
                reports: action.payload
            });
        case t.LOAD_COMPLIANCE_REPORTS:
            return Object.assign({}, state, {
                compliancereports: action.payload
            });
        case t.LOAD_WAITING_REPORTS:
            return Object.assign({}, state, {
                waitingreports: action.payload,
                loadingReports: false,
            });
        case t.LOAD_DELEGATED_REPORTS:
            return Object.assign({}, state, {
                delegatedreports: action.payload,
                loadingReports: false,
            });
        case t.DETAILS_LOADING:
            return Object.assign({}, state, {
                loadingDetails: action.payload,
            });
        case t.LOAD_REPORTDETAILS:
            return Object.assign({}, state, {
                selectedDetailReport: action.payload,
                selectedDetailReportIsDirty: false
            });
        case t.REPORTS_LOADING:
            return Object.assign({}, state, {
                loadingReports: action.payload,
            });
        case t.SET_REPORTS_SELECTEDYEAR:
            return Object.assign({}, state, {
                selectedYear: action.payload
            });
        case t.SET_SELECTED_DETAIL_REPORT_DIRTY:
            return Object.assign({}, state, {
                selectedDetailReportIsDirty: action.payload
            });
        case t.SET_REPORTS_APPROVALORDER:
            return Object.assign({}, state, {
                approvalorder: action.payload
            });
        case t.SET_REPORTS_SELECTEDTAB:
            return Object.assign({}, state, {
                selectedTab: action.payload
            });
        default:
            return state
    }
}